import { cn } from "@/lib/utils";

interface SectionEyebrowProps {
  eyebrow: string;
  heading: string;
  dek?: string;
  align?: "left" | "center";
  tone?: "light" | "dark";
  className?: string;
}

/**
 * Editorial section header - League Spartan caps eyebrow + display heading
 * + optional Merriweather italic dek. Enforces consistent rhythm across
 * homepage sections per EcoCupid design system.
 */
export const SectionEyebrow = ({
  eyebrow,
  heading,
  dek,
  align = "center",
  tone = "light",
  className,
}: SectionEyebrowProps) => {
  const isDark = tone === "dark";
  return (
    <div
      className={cn(
        "max-w-3xl mb-10",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      <p
        className={cn(
          "font-display font-bold uppercase text-xs md:text-sm mb-3 tracking-[0.18em]",
          isDark ? "text-secondary" : "text-primary",
        )}
      >
        {eyebrow}
      </p>
      <h2
        className={cn(
          "font-display font-bold leading-[1.1] tracking-tight text-balance",
          "text-3xl md:text-4xl lg:text-[44px]",
          isDark ? "text-white" : "text-foreground",
        )}
      >
        {heading}
      </h2>
      {dek && (
        <p
          className={cn(
            "font-quote italic mt-4 text-lg md:text-xl leading-snug",
            isDark ? "text-white/85" : "text-black/70",
          )}
        >
          {dek}
        </p>
      )}
    </div>
  );
};
